import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Footer } from "./Footer";
import { ModalWrapper } from "./ModalWrapper";
export function CliModal() {
    return (_jsxs(ModalWrapper, { children: [_jsx("div", { style: { width: "100%", textAlign: "center" }, children: "Waiting for token..." }), _jsx(Footer, {})] }));
}
//# sourceMappingURL=CliModal.js.map